import { Component, OnChanges, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { MatSnackBar } from '@angular/material/snack-bar';

import { MerklisteService } from '../services/merkliste.service';
import { HttpService } from '../services/http.service';


@Component({
  selector: 'app-list-item',
  templateUrl: './list-item.component.html',
  styleUrls: ['./list-item.component.scss']
})
export class ListItemComponent implements OnInit, OnChanges {

  @Input()
  document: any;



  @Output()
  infoRequest: EventEmitter<string> = new EventEmitter<string>();


  zwischenablage: any;

  checked: boolean;
  placesStandort_aktuell = [];
  placesVerortung = [];
  placesKirchenkreis = [];
  getNewParentID = '';
  i: number;
  lang: any;

  constructor(
    private merklisteService: MerklisteService,
    public snackBar: MatSnackBar,
    public http: HttpService
  ) {
    this.merklisteService.MessageCount$.subscribe((merklisteCount: number) => {
      this.checked = this.merklisteService.hasId(this.document['_source']['ID']);
    });


    // console.log('tesssstttinnngggg = ' + this.document['_source']['ID']);

  }


  ngOnInit() {
    this.checked = this.merklisteService.hasId(this.document['_source']['ID']);
    this.http.getLanguage().subscribe( res => {
      console.log(res);
      this.lang = res;
    });
}




  ngOnChanges(changes: any) {
    // console.log(changes);
  }



  public onMerklistToggle(event: any, document: any) {
    const snackBarMessage: string = (event.checked) ?
      'Zur Merkliste hinzugefügt' : 'Von Merkliste entfernt';
    this.snackBar.open(snackBarMessage, '', {
      duration: 1000
    });
    if (event.checked) {
      this.merklisteService.registerItem(document);
    } else {
      this.merklisteService.unregisterItem(document);
    }
  }


  public onInfoClick() {
    this.infoRequest.emit(this.document['_source']['ID']);
  }



  public copyLink(text, id) {

    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = '<a href="https://skulptur.kunstgesch.uni-halle.de/suche#/document/' + id + '">' + text + '</a>';
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);



    this.snackBar.open('Link erzeugt (Zwischenablage)', 'close', {
      duration: 2000,
    });
}




}
